<template>
  <div class="student-question-info-comp" :class="[answerStatus]">
    <div class="title">{{ seqNo }}、{{ questionInfo.subject }}</div>

    <div class="options">
      <div class="option" :class="[calcStatus(option.id)]" v-for="(option, index) in questionInfo.options" :key="index">
        {{ no[index] }} : {{ option.content }}
      </div>
    </div>

    <div class="answer">
      <span class="label">答案：</span>
      {{ showRightSeq }}
    </div>

    <div class="explanation" v-if="questionInfo.explanation">解析：{{ questionInfo.explanation }}</div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import { IStudentQuestion } from 'kuaidong-model'
@Component({
  components: {},
})
export default class StudentQuestionInfo extends BaseComponent {
  @Prop({ type: Object, required: true })
  questionInfo!: IStudentQuestion

  @Prop({ type: Number, required: true })
  seqNo!: number

  no = ['A', 'B', 'C', 'D']

  get answerStatus() {
    switch (this.questionInfo.status) {
      case 0:
        return 'un-do'
      case 1:
        return 'right'
      default:
        return 'wrong'
    }
  }

  get showRightSeq() {
    const rightOptionIndex = this.questionInfo.options.findIndex((item) => {
      return item.is_right
    })
    if (rightOptionIndex !== -1) {
      return this.no[rightOptionIndex]
    } else {
      return '-'
    }
  }

  isUserOption(optionId: string) {
    return this.questionInfo.user_option_ids.includes(optionId)
  }

  calcStatus(optionId: string) {
    return this.isUserOption(optionId) && this.answerStatus
  }
}
</script>
<style lang="less">
.student-question-info-comp {
  margin-top: 16px;
  padding: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 8px;

  &.un-do {
    background: #f7f8fa;
  }

  &.right {
    background: rgba(59, 181, 40, 0.1);
  }

  &.wrong {
    background: #feedee;
  }

  > .title {
    text-align: left;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #4d4d4d;
  }

  > .options {
    margin-left: 16px;
    margin-top: 10px;
    > .option {
      margin-bottom: 10px;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      text-align: left;
      &.wrong {
        color: #f24b53;
      }
      &.right {
        color: #3bb528;
      }
    }
  }

  > .answer {
    margin-top: 10px;
    margin-left: 16px;

    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #2d2f33;
    > .label {
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      color: #3bb528;
    }
  }

  > .explanation {
    margin-top: 12px;
    margin-left: 16px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #81848f;
    text-align: left;
  }
}
</style>
